<script lang="ts" setup>
const { setDefaultHead } = usePageHeadMetaData()

setDefaultHead()
</script>

<template>
  <div class="LayoutDefault">
    <TheHeader />
    <div class="LayoutDefault__content">
      <div class="LayoutDefault__contentContainer">
        <slot />
      </div>
    </div>
    <TheFooter />
    <TheDialogAlert />
    <TheDialogConfirm />
    <TheSnackbar />
  </div>
</template>

<style lang="scss" scoped>
.LayoutDefault {
  @apply gray-333--text;
  @apply min-h-screen h-full w-full;
  @apply flex flex-col;

  &__content {
    @apply flex justify-center;
    @apply gray-f5--background;
    flex: 1 0 auto;

    &Container {
      @apply w-full min-h-[600px];
      @apply white--background;

      max-width: var(--layout-home-content-width);
    }
  }
}
</style>
